import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";

import AxiosUpload from "../../service/AxoisOrder/AxoisUpload";
import { Button, ButtonGroup, Grid, LinearProgress } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { ErrorToast, SuccessToast } from "../../hoc/ToastNotify/ToastNotify";
import TextFieldHelper from "../UI/FormHelper/TextFieldHelper";

class FileUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectFile: null,
      progress: 0,
      loading: false,
      uploaded: false,
      completed: false,
      name: "",
    };

    this.uploadImage = this.uploadImage.bind(this);
    this.handleSelectFile = this.handleSelectFile.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
  }

  uploadImage(file) {
    if (this.state.name === "") {
      ErrorToast("نام فایل را وارد نمایید");
      return;
    }

    const config = {
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 70) / progressEvent.total,
        );
        this.setState({
          progress: percentCompleted,
        });
      }.bind(this),
      headers: { "Content-Type": "multipart/form-data" },
    };
    let fd = new FormData();

    fd.append("file", file);
    fd.append("table_id", this.props.id);
    fd.append("table_type", this.props.table);
    fd.append("name", this.state.name);
    this.setState({
      progress: 0,
      loading: true,
    });

    AxiosUpload.post("/api/upload", fd, config)
      .then((response) => {
        this.setState({
          loading: false,
          uploaded: true,
          completed: true,
          progress: 0,
          selectFile: null,
          name: "",
        });

        this.props.handleReload();

        SuccessToast("فایل با موفقیت آپلود شد.");
      })
      .catch((error) => {
        this.setState({
          loading: false,
          uploaded: false,
          completed: true,
          progress: 0,
          attachment: null,
          url: null,
          url_thumb: null,
          selectFile: null,
          name: "",
        });

        ErrorToast("قادر به ثبت فایل نمی باشد دوباره اقدام کنید");
      });
  }

  handleUploadFile = () => {
    this.uploadImage(this.state.selectFile);
  };

  handleSelectFile = ({ target }) => {
    this.setState({
      selectFile: target.files[0],
    });
  };

  render() {
    const {
      loading,
      progress,
      selectFile,
      attachment,
      url,
      url_thumb,
      hidePic,
      noFlex,
    } = this.state;

    return (
      <Wrapper>
        <Box pt={1}>
          <Box fullWidth={true}>
            {selectFile ? (
              !loading ? (
                <Grid container>
                  <Grid item xs={5}>
                    <TextFieldHelper
                      fieldName={"name"}
                      values={{ name: this.state.name }}
                      label={"نام فایل"}
                      title={"نام فایل"}
                      touched={false}
                      handleChange={(e) => {
                        this.setState({
                          name: e.target.value,
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <Box pt={2}>{selectFile.name}</Box>
                  </Grid>
                  <Grid item xs={2}>
                    <Box pt={1}>
                      <ButtonGroup>
                        <Button
                          variant={"contained"}
                          color={"secondary"}
                          onClick={this.handleUploadFile}
                        >
                          بارگزاری
                        </Button>
                        <Button
                          variant={"contained"}
                          color={"default"}
                          onClick={(e) => {
                            this.setState({
                              selectFile: null,
                            });
                          }}
                        >
                          حذف فایل
                        </Button>
                      </ButtonGroup>
                    </Box>
                  </Grid>
                </Grid>
              ) : (
                <Wrapper>در حال بارگزاری</Wrapper>
              )
            ) : (
              <Wrapper>
                <Button variant="contained" component="label" color={"primary"}>
                  فایل را انتخاب نمایید
                  <input type="file" hidden onChange={this.handleSelectFile} />
                </Button>
              </Wrapper>
            )}
          </Box>
          <Box flexGrow={1} pt={1} pl={2} pr={2}>
            {loading ? (
              <LinearProgress
                color="secondary"
                variant="determinate"
                value={progress}
              />
            ) : (
              ""
            )}
          </Box>
        </Box>
      </Wrapper>
    );
  }
}

export default FileUpload;
